import { withI18nPlaceholders } from '@change-corgi/core/react/i18n';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/homepage/homepage.yml';

import { Homepage as HomepageBase } from './entryPoint';

export const Homepage = withI18nPlaceholders(I18N_PLACEHOLDERS, HomepageBase);
